import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  CircularProgress,
  Link,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "helpers/StyleHelper";
import useGlobalContext from "hooks/globalData";
import { useMemo, useState } from "react";
import { IMediaItem } from "services/KnowfullyAdminClient";
import { MediaType, getMediaType } from "utils/mediaUtils";
import DefaultMedia from "./DefaultMedia";

const useStyles = makeStyles(() => ({
  card: { width: "200px" },
  media: {
    display: "block",
    width: "200px",
    height: "200px",
  },
  cardContent: {
    display: "flex",
    alignItems: "center",
  },
  imageSpinner: {
    marginRight: "5px",
  },
  link: {
    "&:hover": {
      textDecoration: "none",
    },
  },
}));

type MediaLibraryItemProps = {
  mediaLibraryItem: IMediaItem;
  getItemLabel?: (mediaLibraryItem: IMediaItem) => string;
  onClickMediaLibraryItem: (mediaLibraryItem: IMediaItem) => void;
};

const MediaLibraryListItem = ({
  mediaLibraryItem,
  getItemLabel,
  onClickMediaLibraryItem,
}: MediaLibraryItemProps) => {
  const styles = useStyles(useTheme());
  const mediaType = useMemo(() => getMediaType(mediaLibraryItem.contentType!), [
    mediaLibraryItem.contentType,
  ]);
  const { mediaLibraryItemDetailsUrl } = useGlobalContext();
  const isImage = mediaType === MediaType.IMAGE;
  const [loaded, setLoaded] = useState(!isImage);

  return (
    <Card
      sx={styles.card}
      onClick={() => onClickMediaLibraryItem(mediaLibraryItem)}
    >
      <CardActionArea>
        <Link
          href={mediaLibraryItemDetailsUrl(mediaLibraryItem.id)}
          onClick={(e) => e.preventDefault()}
          sx={styles.link}
        >
          {isImage ? (
            <CardMedia
              sx={styles.media}
              component="img"
              style={{ display: loaded ? "block" : "none" }}
              onLoad={() => setLoaded(true)}
              image={mediaLibraryItem.fileUrl}
              title={mediaLibraryItem.alternativeText}
            />
          ) : (
            <DefaultMedia contentType={mediaLibraryItem.contentType!} />
          )}
        </Link>
        <CardContent sx={styles.cardContent}>
          {isImage && !loaded && (
            <CircularProgress size={16} sx={styles.imageSpinner} />
          )}
          <Typography>
            {getItemLabel?.(mediaLibraryItem) ?? mediaLibraryItem.fileName}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default MediaLibraryListItem;
